import { Component, Element, Prop, Watch, h } from '@stencil/core';

import landingActions from '../actions/actions.landing-assigned';
import { actions as pageParamsActions } from '../actions/actions.page-params';
import { state as landingState, on as onLandingStateChange } from '../store/store.landing';
import { DynamicEntryInstallationMode } from '../utils/utils.dynamic-entry';
import { DynamicEntryWorkflow } from '../utils/utils.landing';

@Component({
  tag: 'ico-landing-assigned-hydrator',
})
export class LandingAssignedHydrator {
  @Element() el: HTMLElement;
  div: HTMLDivElement;

  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.Assigned;
  @Prop() dealerId: string = '00000000-0000-0000-0000-000000000000';
  @Prop() installationMode?: DynamicEntryInstallationMode = DynamicEntryInstallationMode.Redirect;
  @Prop() showLandingContact: boolean = true;
  @Prop() vehicle: string;
  @Prop() isAdmin: boolean = false;
  @Prop() tabList: string = '["vin","plate","ymm"]';
  @Prop() inputVin: string = '';
  @Prop() mileage?: number;
  @Prop() theme?: string = '';
  @Prop() ymmDisabled: boolean = false;
  @Prop() modalInfo: string = '';

  // Analytics
  @Prop() offerCode: string = '';
  @Prop() lnxCode: string = '';
  @Prop() entry: string = '';
  @Prop() category: string = '';

  @Watch('modalInfo')
  watchModalInfoHandler(newValue: string) {
    this.updateStateProps('modalInfo', newValue);
  }

  async componentWillLoad() {
    landingActions.onReceivedParams({
      offerCode: this.offerCode,
      dealerId: this.dealerId,
      installationMode: this.installationMode,
      category: this.category,
    });

    pageParamsActions.onReceivedParams({ isAdmin: this.isAdmin, entry: this.entry, lnxCode: this.lnxCode, offerCode: this.offerCode });

    await landingActions.onOptimizelyFetching();

    if (this.dealerId) {
      await landingActions.onFetchDealerInfo(this.dealerId);
    }

    this.setupStateProps();

    onLandingStateChange('set', (prop, value) => {
      this.updateStateProps(prop, value);
    });

    onLandingStateChange('reset', () => {
      this.setupStateProps();
    });
  }

  // updates only the changed prop
  updateStateProps(prop, value) {
    this.div.childNodes.forEach((element) => {
      element[prop] = value;
    });
  }

  // explicitly declare initial state props
  setupStateProps() {
    this.el.childNodes.forEach((element) => {
      element['dynamicEntryWorkflow'] = this.dynamicEntryWorkflow;
      element['offerCode'] = landingState.offerCode;
      element['dealerId'] = landingState.dealerId;
      element['installationMode'] = landingState.installationMode;
      element['assignedMainTitleSubCopy'] = landingState.assignedMainTitleSubCopy;
      element['assignedMainTitleHeader'] = landingState.assignedMainTitleHeader;
      element['assignedMainImageDealershipPhone'] = landingState.assignedMainImageDealershipPhone;
      element['assignedMainImageDealershipName'] = landingState.assignedMainImageDealershipName;
      element['assignedMainImageTitleImage'] = landingState.assignedMainImageTitleImage;
      element['stepByStep'] = landingState.assignedStepByStep;
      element['faqTitle'] = landingState.faqTitle;
      element['faqData'] = landingState.faqData;
      element['contactUsComponent'] = landingState.contactUsComponent;
      element['legalContent'] = landingState.legalContents.assigned;
      element['showLandingContact'] = this.showLandingContact;
      element['vehicle'] = this.vehicle;
      element['inputVin'] = this.inputVin;
      element['mileage'] = this.mileage;
      element['isAssignedOffer'] = landingState.isAssignedOffer;
      element['theme'] = this.theme;
      element['ymmDisabled'] = this.ymmDisabled;
      try {
        element['tabList'] = JSON.parse(this.tabList);
      } catch (error) {
        element['tabList'] = ['vin', 'plate'];
      }
      element['modalInfo'] = this.modalInfo;
    });
  }

  render() {
    return (
      <div class="hydration-state hydration-state--landing-assigned" ref={(el) => (this.div = el)}>
        <slot />
      </div>
    );
  }
}
